import { AxiosInstance } from 'axios';

import { axios } from '../../../../api/axios-instance';
import { preferencesEndpoints } from '../../../../constants';
import { CreatePreferencesInput } from '../../../general/schemas/preference.schema';
import { IPreference } from '../../entities/preference';

class PreferencesApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  createMany = async (createPreferencesInput: CreatePreferencesInput): Promise<IPreference[]> => {
    return this.#requestInstance.post(preferencesEndpoints.preferences, createPreferencesInput);
  };

  getPreferencesByUserId = async (userId: number): Promise<IPreference[]> => {
    return this.#requestInstance.get(preferencesEndpoints.getPreferencesByUserId(userId));
  };

  deleteByUserId = async (userId: number): Promise<void> => {
    return this.#requestInstance.delete(preferencesEndpoints.getPreferencesByUserId(userId));
  };
}

export const preferencesApi = new PreferencesApi(axios);
